export const STAGES = {
  SHARED: { key: 'Shared', label: 'Shared', color: '#00674b' },
  BETA: { key: 'Hawkeye Beta', label: 'Beta', color: '#1565c0' },
  GAMMA: { key: 'Hawkeye Gamma', label: 'Gamma', color: '#e65100' },
};

export const LEASE_DURATION_DEFAULT = 1800 * 1000; // 30 minutes default

export function getTimeLeft(allocatedAt, leaseDuration) {
  const duration = leaseDuration ? leaseDuration * 1000 : LEASE_DURATION_DEFAULT;
  const elapsed = Date.now() - new Date(allocatedAt).getTime();
  const remaining = duration - elapsed;
  if (remaining <= 0) return 'expired';
  const hrs = Math.floor(remaining / 3600000);
  const mins = Math.floor((remaining % 3600000) / 60000);
  const secs = Math.floor((remaining % 60000) / 1000);
  if (hrs > 0) return `${hrs}h ${mins}m left`;
  if (mins > 0) return `${mins}m ${secs}s left`;
  return `${secs}s left`;
}

export function getLeaseDuration(lane) {
  return lane.leaseDuration ? lane.leaseDuration * 1000 : LEASE_DURATION_DEFAULT;
}
